import React, { useEffect, useState } from 'react';
import { fetchHolidayDepartures } from '../../../modules/api';

const DeparturesListing = ({
  holidayId,
  allowSale = true,
  showFlightOptions = false,
}) => {
  const [items, setItems] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [includeFlights, setIncludeFlights] = useState(false);

  const iconsPath = `${ASSET_DIR}/icons/icons.svg`;

  console.log(`holidayId in departure listing is: ${holidayId}`);

  // Helper functions
  const formatDate = (date) => {
    const dateParts = date.split('-');
    return new Date(
      dateParts[2],
      dateParts[1] - 1,
      dateParts[0]
    ).toDateString();
  };

  const simpleDate = (date) => {
    if (date) {
      // Gets the start date of the holiday depending on whether flights are included
      // from optional toggle controls from showFlightOptions
      const dateStr = includeFlights
        ? date.departure_flights.start_date
        : date.departure.start_date;
      return dateStr.split('-').reverse().join('-');
    }
    return '';
  };

  // Hooks
  useEffect(() => {
    (async () => {
      try {
        setIsFetching(true);
        const departures = await fetchHolidayDepartures(holidayId);
        setItems(departures);
        setIsFetching(false);
      } catch (error) {
        console.error('Can not get holiday departures feed', error);
      }
    })();
  }, [holidayId]);

  // JSX Fragments
  const tableHead = (
    <thead>
      <tr>
        <th>Start date</th>
        <th>End date</th>
        <th>Price PP</th>
        <th>
          <span className="u-a11y">
            Flights {includeFlights ? 'included' : 'excluded'}
          </span>
        </th>
        <th>Single supplement</th>
        <th>
          <span className="u-a11y">Book</span>
        </th>
      </tr>
    </thead>
  );

  const toggleFlightsOptions = (
    <div className="c-dates__filters">
      <label className="c-dates__filter" htmlFor="without-flights">
        <input
          id="without-flights"
          checked={!includeFlights}
          value={false}
          type="radio"
          name="date-filter"
          className="c-dates__radio"
          onChange={() => setIncludeFlights(false)}
        />
        <span>Show prices without flights</span>
      </label>

      <label className="c-dates__filter" htmlFor="with-flights">
        <input
          id="with-flights"
          checked={includeFlights}
          value={true}
          type="radio"
          name="date-filter"
          className="c-dates__radio"
          onChange={() => setIncludeFlights(true)}
        />
        <span>Show prices with flights</span>
      </label>
    </div>
  );

  const tableContent = [
    items.map((item) => (
      <tr key={item.id}>
        <td className="c-dates__table__cell" data-th="Start date">
          {includeFlights
            ? item.departure_flights.start_date
            : item.departure.start_date}
        </td>

        <td className="c-dates__table__cell" data-th="End date">
          {includeFlights
            ? item.departure_flights.end_date
            : item.departure.end_date}
        </td>

        <td
          className="c-dates__table__cell c-dates__table__cell--price"
          data-th="Price PP"
        >
          <span className="u-weight--bold u-color--primary">
            £{includeFlights ? item.price_pp_flights : item.price_pp}
          </span>
        </td>

        <td className="c-dates__table__cell c-dates__table__cell--flights">
          <svg className="c-dates__table__plane" role="presentation">
            <use xlinkHref={`${iconsPath}#sprite-plane`} />
          </svg>
          {includeFlights ? 'Including' : 'Excluding'} international flights
        </td>

        <td
          className="c-dates__table__cell c-dates__table__cell--supplement"
          data-th="Single supplement"
        >
          <span className="u-weight--bold u-color--primary">
            £{item.single_supplement}
          </span>
        </td>
        <td className="c-dates__table__cell c-dates__table__cell--book">
          {allowSale && (
            <a
              href={`/contact-us/?hol=${item.id}&date=${simpleDate(
                item
              )}#contact-form`}
              className="c-dates__table__book o-btn"
            >
              Enquire now
            </a>
          )}
        </td>
      </tr>
    )),
  ];

  return (
    <>
      <div className={`c-dates__booking ${isFetching ? 'loading' : ''}`}>
        {items.length > 0 && showFlightOptions && toggleFlightsOptions}

        {items.length > 0 ? (
          <table className="c-dates__table">
            {tableHead}
            <tbody>{tableContent}</tbody>
          </table>
        ) : (
          <div>Sorry there are currently no dates to display.</div>
        )}
      </div>
    </>
  );
};

export default DeparturesListing;
